module.exports = __webpack_public_path__ + "front/img/edm-logo.3dc31319.png";